import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  align-self: center;
  justify-self: center;
  padding: 2rem;
  font-weight: 500;
`;

export default props => <Container {...props} />;
